import React from "react";
import {CardFooter, Col, Row} from "reactstrap";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import NewsApiComponent from "../../../../airports/p11v5-nsru-backend/web-services/NewsApiComponent";
import ReactHtmlParser from "react-html-parser";
import NewsCategoryApiComponent from "../../../../airports/p11v5-nsru-backend/web-services/NewsCategoryApiComponent";
import Card from "reactstrap/lib/Card";
import CardHeader from "reactstrap/lib/CardHeader";
import CardBody from "reactstrap/lib/CardBody";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
import News from "../../../../airports/p11v5-nsru-api/News";

class NewsDisplay1 extends React.Component
{
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            title: <Skeleton color="red" style={{ borderRadius: "20px" }} />,
            createdDate: 'ไม่ระบุ',
            link: "#",
            cover: require("assets/img/dummies/nsru-gray-2x-square.png"),
            newsCategoryId: 1,
            newsCategoryName: "ข่าวประชาสัมพันธ์",
            newsCategoryLogo: require("assets/img/dummies/nsru-gray-2x-square.png"),
            detail: "",
            attachments: []
        }
    }

    componentDidMount() {
        if(this.props.isGen4 == 1)
        {
            this.loadNewsGen4();
        } else {
            this.loadNewsGen5();
        }
    }

    async loadNewsGen4()
    {
        const news = new News();
        var res = await news.readGen4(this.props.id)
        this.newsRender(res)
    }

    async loadNewsGen5()
    {
        const newsApi = new NewsApiComponent();
        newsApi.showNews(this.props.id, res => {
            this.newsRender(res)
        });
    }

    newsRender(res) {
        const backendStorage = process.env.REACT_APP_BACKEND_BASE_URL + "storage/";
        const newsCategoryApi = new NewsCategoryApiComponent();

        // Cover
        const coverSplit = res.cover.split(".");
        switch(coverSplit[coverSplit.length - 1])
        {
            case "jpg":
            case "jpeg":
            case "png":
                var cover = backendStorage + res.cover.replaceAll("\\", "/");
                break;
            default:
                var cover = require("assets/img/dummies/blank-1px.png");
        }

        // Attachment Files
        var attachmentFiles = [];
        JSON.parse(res.attachments).forEach((data, i) => {
            const attachmentSplit = data.download_link.split(".");
            var fileType = "UNKNOW";
            var fileIcon = require("assets/img/file-type-icon/default.png");
            switch(attachmentSplit[attachmentSplit.length - 1])
            {
                case "jpg":
                    fileType = "JPG";
                    fileIcon = require("assets/img/file-type-icon/jpg.png");
                    break;
                case "jpeg":
                    fileType = "JPEG";
                    fileIcon = require("assets/img/file-type-icon/jpeg.png");
                    break;
                case "png":
                    fileType = "PNG";
                    fileIcon = require("assets/img/file-type-icon/png.png");
                    break;
                case "pdf":
                    fileType = "PDF";
                    fileIcon = require("assets/img/file-type-icon/pdf.png");
                    break;
                default:
                    fileType = "UNKNOW";
                    fileIcon = require("assets/img/file-type-icon/default.png");
                    break;
            }

            attachmentFiles.push({
                file_name: data.original_name,
                file_path: backendStorage + data.download_link,
                file_type: fileType,
                icon_path: fileIcon
            })
        })

        var createdDate = new Date(res.created_at);
        var createdDateString = createdDate.toLocaleDateString('th-TH', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        })
        this.setState({
            id: res.id,
            title: res.title,
            createdDate: createdDateString,
            detail: ReactHtmlParser(res.detail),
            link: "/th/news/" + res.id,
            cover: cover,
            attachments: attachmentFiles
        });
        newsCategoryApi.show(res.news_category_id, newspaperRes => {
            if(newspaperRes)
            {
                if(newspaperRes.logo) {
                    var logo = newspaperRes.logo.replaceAll("\\", "/");
                } else {
                    var logo = "";
                }

                this.setState({
                    newsCategoryId: newspaperRes.id,
                    newsCategoryName: newspaperRes.name,
                    newsCategoryLogo: process.env.REACT_APP_BACKEND_BASE_URL + "storage/" + logo,
                });
            }
        });
    }

    render() {

        var color = "red";
        var highlightColor = "white";

        const attachments = []
        this.state.attachments.forEach((attachment, index) => {
            attachments.push(
                <>
                    <Col xs="12" md="12" lg="12">
                        <a href={ attachment.file_path } target="_blank" key={index}>
                            <div style={{
                                backgroundColor: "#F3F3F3",
                                padding: "10px",
                                borderRadius: "5px",
                                marginBottom: "5px",
                                textAlign: "left"
                            }}>
                                <img src={ attachment.icon_path } style={{
                                    height: "30px",
                                    marginRight: "10px"
                                }} />
                                { attachment.file_name }
                            </div>
                        </a>
                    </Col>
                </>
            )
        })



        const renderDetail = () => {
            if (this.state.detail != "") {
                return (
                    <>
                        <div className="mb-1 pl-0 g-font-sarabun" style={{
                            fontSize: "14px"
                        }}>
                            {this.state.detail}
                        </div>
                    </>
                )
            }
        }

        const renderCover = () => {
            const emptyImage = "data:image/png;base64,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"
            if (this.state.cover != "" && this.state.cover != emptyImage) {
                return (
                    <>
                        <img
                            alt="..."
                            className="img-fluid rounded"
                            src={this.state.cover}
                            style={{
                                border: "0px"
                             }}
                        ></img>
                    </>
                )
            }
        }

        const renderAttachmentPanel = () => {
            let hr = ""
            if(this.state.detail != "") {
                hr = (<><hr style={{ margin: '8px' }} /></>)
            }
            if (this.state.attachments.length > 0) {
                return (
                    <>
                        { hr }
                        <h4 style={{ fontSize: '16px', marginTop: 0, fontWeight: 'bold' }}>ไฟล์แนบ</h4>
                        <Row>
                            { attachments }
                        </Row>
                    </>
                )
            }
        }

        return (
            <>
                <Card style={{
                    overflow: "hidden"
                }}>
                    <CardHeader className="d-flex align-items-center" style={{
                        backgroundColor: "#B7EDAD",
                        padding: "10px"
                    }}>
                        <div className="d-flex align-items-center">
                            <div className="mx-3">
                                <Link
                                    className="text-dark font-weight-500 g-font-mitr"
                                    to={"/th/news-view/" + this.state.id}
                                    style={{
                                        fontSize: "18px"
                                    }}
                                >
                                    {this.state.title}
                                </Link>
                                <small className="d-block text-muted">{this.state.createdDate}</small>
                            </div>
                        </div>
                    </CardHeader>
                    <CardBody style={{
                        padding: "12px"
                     }}>
                        { renderDetail() }
                        { renderCover() }
                        { renderAttachmentPanel() }
                    </CardBody>
                    <CardFooter style={{
                        borderTop: "1px solid #BBB",
                        padding: "12px"
                    }}>
                        <Row>
                            <Col xs="12" style={{
                                textAlign: "right",
                                fontSize: "11px"
                            }}>
                                หมวดหมู่: <a href={"/th/news-portal/" + this.state.newsCategoryId}>{this.state.newsCategoryName}</a>
                            </Col>
                        </Row>
                    </CardFooter>
                </Card>
            </>
        );
    }

}

export default NewsDisplay1;
